/**
 * Requires
 */

import $ from 'jquery'
import { clearLocalStorage, loadFromLocalStorage, saveToLocalStorage } from './utils/localStorageUtils'

/**
 * Initialisation
 */

export function initialise() {
  $('[data-toggle="search"]')
    .not('.open')
    .on('click', function() {
      $('input#search').trigger('focus')
    })

  if (window.location.pathname == '/search') {
    const searchValue = $.urlParam('q')
    let recentArray = []
    if (loadFromLocalStorage('search').length > 0) {
      let localStorageArray = loadFromLocalStorage('search')
      recentArray = [searchValue, ...localStorageArray]
    } else {
      recentArray = [searchValue]
    }
    if (recentArray.length > 3) {
      recentArray.pop()
    }
    saveToLocalStorage('search', recentArray)
  }

  if (loadFromLocalStorage('search').length > 0) {
    $('[data-recent-searches]').append(
      '<span class="color-light-grey display-title display-title-s">Recent searches</span>' +
        '<ul class="list-unstyled">' +
        loadFromLocalStorage('search')
          .map(function(item) {
            return '<li><a href="/search?q=' + item + '">' + replaceNotAllowedCharacters(item) + '</a></li>'
          })
          .join('') +
        '</ul>'
    )
  }
}

$.urlParam = function(name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href)
  if (results == null) {
    return null
  }
  return decodeURI(results[1]) || 0
}

function replaceNotAllowedCharacters(string) {
  return string.replace(/[^a-zA-Z0-9]/g, ' ')
}
